import {FormattedMessage} from 'react-intl';
import classNames from 'classnames';
import styles from './login-button.css';
import Button from '../button/button.jsx';
import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';


class LoginButton extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleClick'
        ]);
    }
    handleClick (e) {
            this.props.loginClick();
        
    }
  
    render () {
        const {
             className,
            ...props
        } = this.props;
        return (
           

             <Button
        className={classNames(
            className,
            styles.loginButton
        )}
        onClick={this.handleClick}
    >
        <FormattedMessage
            defaultMessage="Login"
            description="Label for login"
            id="gui.menuBar.login"
        />



    </Button>
        );
    }
}

LoginButton.propTypes = {
    className: PropTypes.string,
    loginClick: PropTypes.func
};





export default LoginButton;